import { render } from "./store-person.vue?vue&type=template&id=153a4863"
import script from "./store-person.vue?vue&type=script&lang=js"
export * from "./store-person.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__